export const moreTooltip = "uxtMH";
export default {moreTooltip};